import {
  maxLengthMessage,
  minLengthMessage,
  postalCodeMessage,
  postalCodeGenericMessage,
  requiredMessage,
} from "../validationMessages";
import {
  postalCodePolandValidator as postalCodeRegex,
  postalCodePolandValidatorOptional as postalCodePolandValidatorOptionalRegex,
  postalCodeGenericValidatorOptional as postalCodeGenericValidatorOptionalRegex,
} from "../validationRegex";

import { trimmedString } from "./trimmedString";

const MIN_LENGTH = 3;
const MAX_LENGTH = 6;
const MAX_GENERIC_LENGTH = 10;

export const postalCodePolandValidator = trimmedString
  .max(MAX_LENGTH, maxLengthMessage(MAX_LENGTH))
  .matches(postalCodePolandValidatorOptionalRegex, {
    message: postalCodeMessage,
    excludeEmptyString: true,
  });
export const postalCodePolandValidatorRequired = trimmedString
  .max(MAX_LENGTH, maxLengthMessage(MAX_LENGTH))
  .required(requiredMessage)
  .matches(postalCodeRegex, postalCodeMessage);

export const postalCodeGenericValidator = trimmedString
  .max(MAX_GENERIC_LENGTH, maxLengthMessage(MAX_GENERIC_LENGTH))
  .matches(postalCodeGenericValidatorOptionalRegex, {
    message: postalCodeGenericMessage,
    excludeEmptyString: true,
  });
export const postalCodeGenericValidatorRequired = trimmedString
  .min(MIN_LENGTH, minLengthMessage(MIN_LENGTH))
  .max(MAX_GENERIC_LENGTH, maxLengthMessage(MAX_GENERIC_LENGTH))
  .required(requiredMessage);
